export interface MatrixQuadrantItem {
  id: string;
  name: string;
  quadrant: string;
}

const QUADRANT_META: Record<string, { title: string; sub: string; labelClass: string; tagClass: string }> = {
  'quick-wins': { title: 'Quick wins', sub: 'High impact · Low effort', labelClass: 'text-alpine-green-400', tagClass: 'text-alpine-green-400/90 border-alpine-green-500/30 bg-alpine-green-500/7' },
  ui: { title: 'Do', sub: 'Urgent + Important', labelClass: 'text-luminous-coral-700', tagClass: 'text-luminous-coral-700/90 border-luminous-coral-700/30 bg-luminous-coral-700/7' },
  'big-bets': { title: 'Big bets', sub: 'High impact · High effort', labelClass: 'text-electric-mustard-600', tagClass: 'text-electric-mustard-600/90 border-electric-mustard-600/30 bg-electric-mustard-600/7' },
  in: { title: 'Schedule', sub: 'Important, not urgent', labelClass: 'text-electric-mustard-600', tagClass: 'text-electric-mustard-600/90 border-electric-mustard-600/30 bg-electric-mustard-600/7' },
  'fill-ins': { title: 'Fill-ins', sub: 'Low impact · Low effort', labelClass: 'text-[var(--text-sec)]', tagClass: 'text-[var(--text-sec)] border-[var(--rule-bright)] bg-[var(--bg-raised)]/[0.03]' },
  un: { title: 'Delegate', sub: 'Urgent, not important', labelClass: 'text-[var(--text-sec)]', tagClass: 'text-[var(--text-sec)] border-[var(--rule-bright)] bg-[var(--bg-raised)]/[0.03]' },
  avoid: { title: 'Avoid', sub: 'Low impact · High effort', labelClass: 'text-luminous-coral-700', tagClass: 'text-luminous-coral-700/70 border-luminous-coral-700/25 bg-luminous-coral-700/5' },
  nn: { title: 'Eliminate', sub: 'Neither', labelClass: 'text-[var(--text-ter)]', tagClass: 'text-[var(--text-ter)] border-[var(--rule)]' },
};

interface MatrixQuadrantsLiveProps {
  /** Quadrant keys in display order (2x2 grid, row-major). */
  quadrantOrder: string[];
  items: MatrixQuadrantItem[];
}

export function MatrixQuadrantsLive({ quadrantOrder, items }: MatrixQuadrantsLiveProps) {
  const byQ = (q: string) => items.filter(i => i.quadrant === q);

  return (
    <div className="grid grid-cols-2 gap-2">
      {quadrantOrder.map(q => {
        const meta = QUADRANT_META[q] ?? { title: q, sub: '', labelClass: 'text-[var(--text-sec)]', tagClass: 'text-[var(--text-sec)] border-[var(--rule-bright)]' };
        const list = byQ(q);
        return (
          <div key={q} className="border border-[var(--rule)] bg-[var(--surface)] p-3 min-h-[90px]">
            <div className={`font-heading text-[0.54rem] tracking-[0.12em] uppercase ${meta.labelClass}`}>{meta.title}</div>
            {meta.sub && <div className="font-body text-[0.65rem] text-[var(--text-ter)] mb-2">{meta.sub}</div>}
            <div className="flex flex-wrap gap-1">
              {list.map(item => (
                <span key={item.id} className={`font-body text-[0.72rem] px-2 py-0.5 rounded border ${meta.tagClass}`}>
                  {item.name}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
